<template>
 <!-- <div style="min-height:34px"> -->
    <div class="block  w-100"  >
		
		<div  class="footer-bottom">
			<el-button disabled >添加</el-button>
			 <el-button >编辑</el-button>
			 <el-button >详情</el-button>
			 <el-button >复制</el-button>
			 <el-button >删除</el-button>
			  <el-button >配置列</el-button>
			 <el-button >批量处理</el-button>
			 <el-button >导入</el-button>
			 <el-button >导出</el-button>
		</div>
   
  </div>
  <!-- </div> -->
</template>
<script>
    export default {
     props: {
     	
     },
      data() {
        return {
			button:'',
			
        }
      },  
      methods: {
		  operateCommand(e){
		  	 this.$store.commit("saveOperate", e);
		   this.$emit("callbackOperate",{operate:e});   
		  },
   currentChange(index){
     this.$emit("callbackIndex", index); //将值传给父组件
   },
   sizeChange(e){
	  var list= this.$store.state.list;
	  if(e==list.pageSize){return}
	  list.pageSize=e;
	  localStorage.setItem('PAGESIZE',e)
	   this.$store.commit("saveList", list);
	      this.$emit("callbackIndex", 1); //将值传给父组件
   }
   
      },
	 
	 computed:{
	 	getButton(){
	 		return this.$store.state.menu.meta?(this.$store.state.menu.meta.button||''):""
	 	},
		getPage(){
			return this.$store.state.list;
		}
	 }
      }
      
  </script>
 <style >
	 .block{display: flex;align-items: center;justify-content: space-between;}
	 .footer-bottom{display: flex;align-items: center;justify-content: space-between;}
	 .el-pagination__sizes{
		 margin: 0px;
	 }
	.el-pagination .el-select .el-input{
		margin-right: 0px;
	}
	/*  .el-pagination__total,.el-pagination__jump {
	      color:#409EFF!important ;
	  }
	  .el-pagination.is-background .el-pager li {
	     color: #409EFF;
	         border-color: #c6e2ff;
	         background-color: #ecf5ff;
	  }
	  .el-pagination.is-background .btn-prev:disabled {
	 
	  } */
	
  </style> 